<app-navbar-style-one></app-navbar-style-one>

<div id="carouselExample" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div *ngFor="let offer of offers; let i = index" 
         class="carousel-item" 
         [class.active]="i === 0">
      <a class="w-100" href="/offers"><img [src]="offer.image" class="d-block w-100" [alt]="'Slide ' + (i + 1)"></a>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>

<!-- <div class="home-slider owl-carousel owl-theme d-none">
    <div class="slider-item" *ngFor="let offer of offers" 
         [style.background-image]="'url(' + offer.image + ')'">
        <div class="d-table">
            <div class="d-table-cell"></div>
        </div>
    </div>
</div> -->

<section class="our-menus py-5">
  <div class="container">
    <div class="text-center mb-5 lunchMenuItems-cateringMenuItems">
      <h2 class="display-4 fw-bold">Our Menus</h2>
      <p class="lead">"A Curated Selection of Dishes, Designed to Delight Every Palate."</p>
    </div>

    <div class="row g-4 lunchMenuItems-cateringMenuItems">
        <!-- Lunch Special Card -->
        <div class="col-md-6">
            <div class="card h-100 border-0">
                <div class="card-body p-4 text-center">
                    <a href="/menu/maincategory/{{lunchCategoryId[0]}}/lunch">
                        <img src="../../../../assets/img/home2/lunch.jpg" class="img-fluid text-center animate__animated animate__backInLeft" alt="lunch">
                    </a>
                    <div>
                        <h3 class="h4 mb-3 mt-5 lunch-catering-title">Lunch Special</h3>
                        <p class="mb-4 lunch-catering-paragraph">"Great Taste, No Wait - Your Ideal Lunch Break Starts Here."</p>
                        <button class="btn btn-primary" (click)="showMenu('lunch')">Show Menu</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Catering Menu Card -->
        <div class="col-md-6 Catering">
            <div class="card h-100 border-0">
                <div class="card-body p-4 text-center">
                    <div class="ordering">
                        <h3 class="h4 mb-3 lunch-catering-title">Catering Menu</h3>
                        <p class="mb-4 lunch-catering-paragraph">"From Our Kitchen to Your Event - Exceptional Catering Services You Can Count On."</p>
                        <button class="btn btn-primary" (click)="showMenu('catering')">
                            Show Menu
                        </button>
                    </div>
                    <a href="/menu/maincategory/{{cateringCategoryId[0]}}/catering">
                        <img src="../../../../assets/img/home2/catering.jpg" class="img-fluid text-center animate__animated animate__backInRight mt-5" alt="catering">
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-4 lunchMenuItems d-none">
        <div class="col-12">
            <img src="../../../../assets/img/home2/arrow-back.png" width="30" (click)="showLunchCatringMenu()" alt="Banner Images">
        </div>
        <div class="col-md-6">
            <div class="lunchCardMenu h-100">
                <div class="card-body p-4 text-center">
                    <h3 class="h4 mb-3 lunch-catering-title mt-3">Lunch Special</h3>
                    <p class="mb-4 lunch-catering-paragraph">"Enjoy our delicious lunch specials featuring crispy wings, loaded sandwiches, and your favorite sides — all at unbeatable midday prices."</p>
                    <a *ngIf="lunchCategoryId && lunchCategoryId.length > 0" routerLink="/menu/maincategory/{{lunchCategoryId[0]}}/lunch" class="btn btn-primary mt-5">Order Now</a>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <a href="/menu/maincategory/{{lunchCategoryId[0]}}/lunch">
                <img [src]="lunchImage" class="menuImg animate__animated animate__wobble" width="670" alt="Banner Images">
            </a>
        </div>
    </div>
    <div class="row g-4 cateringMenuItems d-none">
        <div class="col-12">
            <!-- <i class="bx bx-arrow-back" (click)="showLunchCatringMenu()"></i> -->
            <img src="../../../../assets/img/home2/arrow-back.png" width="30" (click)="showLunchCatringMenu()" alt="Banner Images">
        </div>
        <div class="col-md-6">
            <div class="cateringCardMenu h-100">
                <div class="card-body p-4 text-center">
                    <h3 class="h4 mb-3 lunch-catering-title mt-3">Catering Special Menu</h3>
                    <p class="mb-4 lunch-catering-paragraph">"Enjoy our delicious lunch specials featuring crispy wings, loaded sandwiches, and your favorite sides — all at unbeatable midday prices."</p>
                    <a *ngIf="cateringCategoryId && cateringCategoryId.length > 0" routerLink="/menu/maincategory/{{cateringCategoryId[0]}}/catering" class="btn btn-primary orderBtn mt-5">Order Now</a>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <a href="/menu/maincategory/{{cateringCategoryId[0]}}/catering">
                <img [src]="cateringImage" class="menuImg animate__animated animate__wobble" width="670" alt="Banner Images">
            </a>
        </div>
    </div>
  </div>
</section>

<section class="mt-5">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12 text-center">
                <h3>What We Serve</h3>
                <p class="mt-2 mb-5 tableServe" style="padding: 0 20%;">"At our place, it's all about crispy wings, loaded sandwiches, and unforgettable flavor in every bite."</p>
            </div>
        </div>
    </div>
   
    <div class="container-fluid px-0 mb-5">
        <div class="menu-table">
            <div class="menu-table-row">
                <div *ngFor="let item of menuItems" class="menu-table-cell">
                    <div class="menu-item">
                        <div class="menu-icon">
                            <a class="menuImage" routerLink="menu/subcategory/{{item.id}}/{{item.name}}">
                                <img [src]="item.avatar" [alt]="item.name" width="90" class="img-fluid">
                            </a>
                        </div>
                        <h5>
                            <a routerLink="menu/subcategory/{{item.id}}/{{item.name}}">{{item.name}}</a>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-5">
                <div class="text-center">
                    <img src="assets/img/home2/cooker.png" class="animate__animated animate__fadeInLeftBig" alt="Testimonial Images">
                </div>
            </div>
            <div class="col-lg-6 col-md-7 d-flex justify-content-center align-items-center">
                <div class="flex-column ">
                    <div class="makeBox animate__animated animate__fadeInRight">
                        <h3>Who We Are</h3>
                        <p>Established in 2007, Bayonne BBQ & Wings is a family-owned and operated restaurant proudly serving the Bayonne, New Jersey community with delicious, home-style barbecue.<br></p>
                        <p>For over a decade, we’ve been dedicated to crafting meals that bring people together — from our fall-off-the-bone tender ribs to our crispy, juicy wings and perfectly seasoned chicken. Every dish is made with care, passion, and a commitment to quality that our customers have loved for years.</p>
                        <p>Whether you’re craving a classic BBQ meal or something new, Bayonne BBQ & Wings has something for everyone. Come experience why we’ve been a local favorite since 2007.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<app-footer-style-two></app-footer-style-two>